import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";
import { phoneNumberChange } from "@api/users/me/phoneNumberChange/path";
import { verifyUserEmail } from "@api/users/me/verifyUserEmail/path";
import { deleteRequests } from "@api/users/me/deleteRequests/path";

const pathBase = `/users/me/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const me = {
  get: apiPathFunc(pathBase),
  phoneNumberChange,
  verifyUserEmail,
  deleteRequests,
};
